<template>
  <div class="dea-evaluation-modal" data-test="evaluation-modal">
    <HeaderFlow :logos="personalAreaLogoList" :sections="{}" @closed="$emit('close-modal')"> </HeaderFlow>
    <div class="grid grid--wide">
      <slot name:content></slot>
      <div class="xs-12">
        <div class="dea-evaluation-modal__link">
          <span class="dea-heading--regular-xs">Non hai ancora in mente un titolo? </span>
          <Links
            class="dea-links dea-links--pointer"
            :class="`dea-links--${linkColor}`"
            label-class="dea-heading--medium-xs"
            :href="catalogLink"
            icon="go-to"
            target="_blank"
            >Esplora il catalogo</Links
          >
        </div>
        <div class="dea-evaluation-modal__search">
          <SearchBookAutosuggest :config="config" />
          <div class="dea-heading--medium__xm dea-evaluation-modal__search-info">Digita almeno 4 caratteri</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderFlow from "@/components/patterns/HeaderFlow";
import Links from "@/components/elements/Links";
import SearchBookAutosuggest from "~/components/books/components/SearchBookAutosuggest";

export default {
  name: "BookEvaluationModal",
  components: {
    HeaderFlow,
    Links,
    SearchBookAutosuggest,
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    linkColor: {
      type: String,
      default: "",
    },
    catalogLink: {
      type: String,
      required: true,
    },
    personalAreaLogoList: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    document.body.style.overflowY = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflowY = "auto";
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-evaluation-modal {
  background-color: $dea-color-white;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;

  .dea-ico-copia-digitale {
    font-size: $dea-logo-size-medium;
    margin-top: $space-x-large;
  }

  &__title {
    margin: $space-base 0;
  }

  &__evaluation {
    margin-top: $space-x-large;
  }

  &__link {
    margin-top: $space-x-small;

    .dea-links__icon {
      margin-left: $space-x-small;
    }
  }

  &__search-info {
    color: $dea-color-grey-medium;
  }

  .header--flow {
    .logo-deascuola--desktop {
      height: $dea-logo-size-header-center;
      width: auto;
    }

    .logo-area-personale--desktop {
      height: $dea-logo-size-small;
      width: auto;
    }
  }
}
</style>
